import {
  SET_CALL_CENTER_READY,
  SET_CALL_CENTER_CONTROL_NUMBER
} from "typeConstants";

const setCallCenterReady = (callCenterReady, callBack = null) => {
  return dispatch => {
    dispatch({
      type: SET_CALL_CENTER_READY,
      payload: callCenterReady
    }).then(callBack);
  };
};

const setCallCenterControlNumber = (controlNumber, callBack = null) => {
  return dispatch => {
    dispatch({
      type: SET_CALL_CENTER_CONTROL_NUMBER,
      payload: controlNumber
    }).then(callBack);
  };
};

export {
  setCallCenterReady,
  setCallCenterControlNumber,
};
